export const USER_REQUESTED = 'USER_REQUESTED';
export const USER_SET_STATUS = 'USER_SET_STATUS';
export const USER_SET_NOTIFY_SETTINGS = 'USER_SET_NOTIFY_SETTINGS';
export const USER_UPDATE = 'USER_UPDATE';